module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_7-f451264e32c7fcc0046c71ff9eec52c5.jpg";